import React from 'react';
import { useStyles } from './InstructionCard.styles';
import { IInstructionListItem } from '../../../../services/support/instructions/supportInstructions.types';
import { Grid } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import { Paths } from '../../../../utils/routerUrls';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import TooltipOne from '../../../TooltipOne/TooltipOne.component';

interface InstructionProps {
  deleteFunc?: () => void;
  likeFunc?: () => void;
  dislikeFunc?: () => void;
  isEdit: boolean
  instructionProp: IInstructionListItem;
}

export const InstructionCard: React.FC<InstructionProps> = ({ instructionProp, deleteFunc, likeFunc, dislikeFunc, isEdit } ) => {
  const classes = useStyles();

  return (
    <Grid item xs={3}>
      <div className={classes.instructionCardFlex} style={{ position: 'relative', padding: 5 }}>

        {isEdit && <p style={{ position: 'absolute', right: 0, cursor: 'pointer' }}> 
          <NavLink to={`${Paths.supportInstructions}/${instructionProp.id}/edit`}><EditOutlinedIcon style={{ marginRight: '10px', color: 'black' }} /></NavLink>
          {!instructionProp.isLiked && <a onClick={likeFunc}><ThumbUpOutlinedIcon style={{ marginRight: '10px', color: 'black' }} /></a>}
          {instructionProp.isLiked && <a onClick={dislikeFunc}><ThumbUpOutlinedIcon style={{ marginRight: '10px', color: 'blue' }} /></a>}

          <span onClick={deleteFunc}><DeleteOutlineIcon style={{ marginRight: '10px' }}/></span>
        </p>} 

        <p className={`${classes.instructionTitle} ${isEdit ? classes.instructionTitleEdit : ''}`}><strong>{instructionProp.title}</strong></p>
        <p className={classes.instructionDescription}>{instructionProp.description}</p>
        <p className={classes.instructionDetails}>
          <TooltipOne title="Dowiedz się więcej o wybranej instrukcji interaktywnej" placement="top">
            <NavLink to={`${Paths.supportInstructions}/${instructionProp.id}`}>Dowiedz się więcej...</NavLink>
          </TooltipOne>
        </p>
      </div>
    </Grid>
  );
};
